import { ChevronRightIcon, HomeIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { translations } from '../../../../../utils/language'


export default function Navbar(props) {

    const location = useLocation()
    const history = useHistory()
    const [route, setRoute] = useState("")
    const language = useSelector((state) => state.reducerLanguage);

    useEffect(() => {
        setRoute(location.pathname.split("/").reverse()[0])
    }, [location])


    return (
        <nav style={{ marginBottom: "20px" }} aria-label="Breadcrumb" className="flex">
            <ol role="list" className="flex items-center space-x-4">
                <li>
                    <div>
                        <a
                            onClick={() => { history.push("/") }}
                            href="javascript:void(0);"
                            className="text-gray-400 hover:text-gray-500">
                            <HomeIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0" />
                            <span className="sr-only">Home</span>
                        </a>
                    </div>
                </li>


                <li key={"Produtos"}>
                    <div className="flex items-center">
                        <ChevronRightIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />
                        <a
                            onClick={() => { history.push(`/produtos${location.search}`) }}
                            href={"javascript:void(0);"}
                            aria-current={"page.current" ? 'page' : undefined}
                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                            {translations["page-products-title"][language.data]}
                        </a>
                    </div>
                </li>

                {/* <li key={"Produtos"}>
                    <div className="flex items-center">
                        <ChevronRightIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />
                        <a
                            style={{
                                maxWidth: "300px", // Define a largura máxima do elemento
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                            //onClick={() => { history.push("/produtos") }}
                            href={"javascript:void(0);"}
                            aria-current={"page.current" ? 'page' : undefined}
                            className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                        >
                            {props?.product?.name}
                        </a>
                    </div>
                </li> */}

                {route == "midias" &&
                    <li key={"midias"}>
                        <div className="flex items-center">
                            <ChevronRightIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />
                            <a
                                href={"javascript:void(0);"}
                                aria-current={"page.current" ? 'page' : undefined}
                                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                            >
                                {translations["Mídias"][language.data]}
                            </a>
                        </div>
                    </li>}

                {route == "variacoes" &&
                    <li key={"variações"}>
                        <div className="flex items-center">
                            <ChevronRightIcon aria-hidden="true" className="h-5 w-5 flex-shrink-0 text-gray-400" />
                            <a
                                href={"javascript:void(0);"}
                                aria-current={"page.current" ? 'page' : undefined}
                                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                            >
                                {translations["page-variants-title"][language.data]}
                            </a>
                        </div>
                    </li>}

            </ol>
        </nav>
    )
}
